import { uiText } from '../../i18n';
import { record, rows, text } from '../studio/studio-content';
import type { CircleFormState } from '../studio/circle/CircleFieldInput';
import { VideoSource } from './VideoSource';
export function VideoProductTray({ state }: { state: CircleFormState }) {
  const fields = state.form?.fields.filter(f => /^photo(?:_[2-5])?$/.test(f.key) && f.upload?.kind === 'photo') ?? [];
  const selected = state.inputs.main_photo || '1';
  const motions = rows(record(state.form?.constraints?.video).motions);
  return (
    <>
      <fieldset>
        <legend>
          {uiText('Фото товара')} · {fields.filter(f => state.inputs[f.key]).length}/{fields.length}
        </legend>
        <p>{uiText('Снимем из главного фото. Выберите главное фото для кадрирования.')}</p>
        {fields.map((field, index) => (
          <div key={field.key}>
            <button
              type="button"
              disabled={state.locked || !state.inputs[field.key]}
              aria-pressed={selected === String(index + 1)}
              onClick={() => state.setInputs(v => ({ ...v, main_photo: String(index + 1), crop_x: '0.5', crop_y: '0.5', zoom: '1' }))}
            >
              {uiText('Главное фото')} {index + 1}
            </button>
            <VideoSource field={field} crop={selected === String(index + 1)} state={state} />
          </div>
        ))}
      </fieldset>
      {state.form?.fields.some(f => f.key === 'motion') && (
        <fieldset>
          <legend>{uiText('Движение')}</legend>
          <button
            type="button"
            aria-pressed={!state.inputs.motion}
            disabled={state.locked}
            onClick={() => state.setInputs(v => ({ ...v, motion: '' }))}
          >
            {uiText('Без движения')}
          </button>
          {motions
            .filter(m => /^10[1-9]$|^110$/.test(String(m.id)))
            .map(m => (
              <button
                type="button"
                key={String(m.id)}
                aria-pressed={state.inputs.motion === String(m.id)}
                disabled={state.locked}
                onClick={() => state.setInputs(v => ({ ...v, motion: String(m.id) }))}
              >
                {text(m.name)}
                {m.hit === true ? ` · ${uiText('Хит')}` : ''}
                {m.new === true ? ` · ${uiText('Новое')}` : ''}
              </button>
            ))}
        </fieldset>
      )}
    </>
  );
}
